import store from "../store";
import Axios from "axios";
import { CachePocily } from "../common/Cache";
import cacheKey from "../constant/cacheKey";
var typeListUrl = 'supplierclientapi/notice/ui';
var messageTypeDecorator = function (target, propertyKey, descriptor) {
    var oldFunc = target[propertyKey];
    descriptor.value = function () {
        var promise = oldFunc.apply(target, arguments);
        var typePromsie = CachePocily.getInstance().getDataPromise(cacheKey.MSG_TYPE_LIST, function () { return Axios.get(typeListUrl); });
        return Promise.all([promise, typePromsie]).then(function (res) {
            store.dispatch('updateMsgType', res[1].data.data);
            return res[0];
        });
    };
    return descriptor;
};
export default messageTypeDecorator;
